import { html, View } from 'rune-ts';
import { typo } from '../../../../shared/typography/typo';
import klass from './SearchEmptyScreen.module.scss';

export type SearchEmptyScreenData = { klass?: string; image_src?: string };

export class SearchEmptyScreen extends View<SearchEmptyScreenData> {
  image_src: string;
  title: string;
  body: string;

  constructor(data: SearchEmptyScreenData = {}) {
    super(data);
    this.image_src = this.data.image_src || this.defaultImageSrc;
    this.title = ET('mps2::search::empty_title');
    this.body = ET('mps2::search::empty_body');
  }

  override template() {
    return html`<div class="${klass.search_empty} ${this.data.klass}">
      <img class=${klass.image} src="${this.image_src}" alt="" />
      <span class="${klass.title} ${typo('20_bold')}">${this.title}</span>
      <span class="${klass.body} ${typo('16_medium')}">${html.preventEscape(this.body)}</span>
    </div>`;
  }

  get defaultImageSrc() {
    return '//s3.marpple.co/files/u_2232571/2024/6/original/a57e2be49b0b2c16047dc905043fa2e5c9fbff141.png';
  }
}
